// Direct CouchDB access enabled
import { getDB, testDirectConnection, updateDBHeaders as updateDirectDBHeaders } from './direct-couchdb';

// Export getDB directly
export { getDB };

// Single persistent database instance
export const localDB = new Proxy({}, {
  get(target, prop) {
    return getDB()[prop];
  }
});

export const remoteDB = new Proxy({}, {
  get(target, prop) {
    return getDB()[prop];
  }
});

export const updateDBHeaders = () => {
  updateDirectDBHeaders();
};

export const testRemoteConnection = testDirectConnection;
